var render = function render(){var _vm=this,_c=_vm._self._c;return _c('a-layout-header',[_c('div',{staticClass:"header-col header-brand"},[_c('h6',[_vm._v("Order Manager")])]),_c('div',{staticClass:"header-col header-nav"},[_c('a-menu',{staticClass:"menu-large",attrs:{"mode":"horizontal"}}),_c('div',{staticClass:"menu-small"})],1),_c('div',{staticClass:"header-col header-btn"})])
}
var staticRenderFns = []

export { render, staticRenderFns }